import palette from 'theme/palette';

const MuiCssBaseline = {
  styleOverrides: {
    '*::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5',
    },
    '*::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      backgroundColor: palette.background.default,
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: palette.grey.dark,
      border: '0',
    },
  },
};

export default MuiCssBaseline;
